var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentalHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 60,
    viewBox: "0 0 84 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 60,
    rx: 29.4545,
    fill: "#D8ECED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10992_2767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.713 29.1476C43.713 29.1476 47.5044 27.7696 47.5044 25.0137C47.5044 23.8717 46.5756 22.9429 45.4336 22.9429C44.7408 22.9429 44.0937 23.2931 43.713 23.8717C43.0811 22.92 41.7945 22.6612 40.8429 23.2931C40.2643 23.6737 39.9217 24.3209 39.9141 25.0137C39.9141 27.7696 43.7054 29.1476 43.7054 29.1476H43.713Z",
    stroke: "#148D9B",
    strokeWidth: 1.28345,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8488 47.7388V38.6182C52.8488 37.3773 53.2523 36.1439 54.0669 35.2075C58.8708 29.6803 58.6196 21.1231 52.9554 15.9081C49.0955 12.3528 43.4237 11.2717 38.5513 13.2207C33.0774 15.4133 29.7504 20.5902 29.7581 26.1326V27.0005C29.7581 27.1908 29.7048 27.3812 29.6134 27.541L26.6976 32.619C26.3854 33.1672 26.5986 33.8752 27.1772 34.1417L29.1414 35.0781C29.5221 35.2608 29.7657 35.6415 29.7657 36.0602V39.9886C29.7657 41.8995 31.3188 43.4526 33.2297 43.4526H36.2673C37.3332 43.4526 38.1935 44.3129 38.1935 45.3787V47.7312H52.864L52.8488 47.7388Z",
    stroke: "#148D9B",
    strokeWidth: 1.28345,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.713 33.3425C47.9177 33.3425 51.3262 29.934 51.3262 25.7294C51.3262 21.5247 47.9177 18.1162 43.713 18.1162C39.5084 18.1162 36.0999 21.5247 36.0999 25.7294C36.0999 29.934 39.5084 33.3425 43.713 33.3425Z",
    stroke: "#148D9B",
    strokeWidth: 1.28345,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10992_2767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.4321,
    height: 37,
    fill: "white",
    transform: "translate(25.7839 11.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentalHealth);
export default __webpack_public_path__ + "static/media/MentalHealth.a0026fdd27a4098ae93cc1299e37f30b.svg";
export { ForwardRef as ReactComponent };